export default {
  common: {
    back: '← 返回',
    backHome: '← 返回首页',
    loading: '加载中...',
    submitting: '提交中...',
    querying: '查询中...',
    retry: '重新查询',
    pageTitle: 'Shaiya - 卡台',
    updateTitle: '页面版本已过期',
    updateBody: '兑换页已发布新版本 {version}。刷新后会加载最新页面，并清除本机队列缓存（卡密本身不受影响）。',
    updateRefresh: '刷新并清除缓存',
  },
  home: {
    brand: 'Shaiya - 卡台',
    brandSub: '卡密兑换',
    eyebrow: 'SHAIYA · VOID',
    heroTitle: '卡密兑换',
    heroSub: '检查 Session 通过即可开通。已开通请稍后刷新查看，以到账为准；未到账联系客服，不要重复提交。',
    ctaPrimary: '立即兑换',
    ctaProgress: '进度查询',
    flowTitle: '三步开通',
    chips: {
      session: 'Session 通过即 OK',
      handoff: '已受理 · 以到账为准',
      once: '请勿重复提交',
    },
    services: {
      recharge: { title: '卡密兑换', en: 'Redeem', cta: '开始兑换', p1: '输入卡密，检查 Session 后自动开通', p2: '提交 Session', p3: '确认提交申请' },
      batch: { title: '批量兑换', en: 'Batch', cta: '批量开始', p1: '多张卡密按序配对提交', p2: '导入 Excel Session', p3: '按序配对自动提交' },
      lookup: { title: '卡密查询', en: 'Lookup', cta: '查询卡密', p1: '查看是否已使用及充值邮箱', p2: '查看是否已使用', p3: '显示充值邮箱' },
      progress: { title: '进度查询', en: 'Progress', cta: '查看进度', p1: '按卡密或本机队列查看开通进度' },
      billing: { title: '账单查询', en: 'Billing', cta: '查询账单', p1: '粘贴 Session 查看订阅状态', p2: '查询账单信息', p3: '查看订阅状态' },
    },
    flows: {
      submit: { title: '提交流程', s1: '输入卡密，确认套餐', s2: '检查 Session，通过即显示 OK', s3: '已开通，请稍后刷新，以到账为准' },
      batch: { title: '批量兑换', s1: '验证卡密 — 批量预览', s2: '导入 Session — Excel/CSV 自动识别', s3: '配对提交 — 按序兑换并看进度' },
      lookup: { title: '卡密查询', s1: '输入卡密 — 完整卡密', s2: '查询状态 — 是否已使用', s3: '查看邮箱 — 充值到哪个账号' },
      billing: { title: '账单查询', s1: 'Session 输入 — 粘贴 Token', s2: '查询账单 — 点击查询后进入', s3: '账单结果 — 查询后展示' },
    },
  },
  progress: {
    title: '进度查询',
    subtitle: '输入卡密查询，或以到账为准',
  },
  redeemTabs: {
    single: '立即兑换',
    batch: '批量充值',
    lookup: '卡密查询',
    billing: '账单查询',
    progress: '进度查询',
  },
  batch: {
    title: '批量兑换',
    subtitle: '验证 CDK → Session 或邮箱密码配对 → 按序提交看进度',
    panelTitle: '批量充值',
    panelHint: '验证 CDK → 选择 Session 或邮箱密码 → 按顺序配对提交',
    cdkListLabel: '卡密列表（每行一个，最多 {max}）',
    cdkPlaceholder: 'SXC-XXXX-XXXX-XXXX-XXXX\n…',
    cdkRecognized: '已识别 {n} 个卡密',
    cdkQueueHint: '大批量将并发排队处理，请确保上游额度充足',
    credMode: '凭证方式',
    modeSession: 'Session',
    modeMailbox: '邮箱密码',
    mailboxLabel: '邮箱密码列表（每行一个）',
    mailboxPlaceholder: 'email----password\nemail:password\nemail,password',
    mailboxLinePlaceholder: 'email----password 或 email:password',
    mailboxRecognized: '已识别 {n} 条邮箱密码',
    mailboxImportBtn: '导入 Excel / CSV / TXT（邮箱+密码）',
    mailboxHint: '支持 mail.tm / Outlook。格式：email----password；Excel 需含「邮箱」「邮箱密码」列',
    mailboxPairHint: '配对规则：第 1 张有效 CDK ↔ 第 1 条邮箱密码，依次类推。下方看实时进度（含账号与卡尾号）。',
    excelLabel: 'Session Excel（可选）',
    clearImport: '清空已导入',
    importing: '识别中…',
    imported: '已导入 {n} 条 · 点击更换',
    importBtn: '导入 Excel / CSV（自动识别 session 列）',
    excelHint: '支持 xlsx / csv。gptbuy 格式「邮箱,邮箱密码,GPT密码,token,session」自动用 session 列；兑换需完整 JSON（含 sessionToken）或五段 JWE，不能只用 Access Token',
    verifying: '验证中…',
    verifyStart: '批量验证并开始',
    verifyingKeys: '正在批量验证卡密…',
    statTotal: '全部',
    statWait: '待凭证',
    statRun: '处理中',
    statOkFail: '成功/失败',
    currentOrdinal: '第 {n} / {total} 张',
    remaining: '剩余 {n} 待贴',
    willUseAccount: '将使用账号：',
    sessionPlaceholder: '粘贴完整 Session JSON（须含 sessionToken）或五段 JWE；导入后自动填入',
    submitting: '提交中…',
    submitNext: '提交并继续下一张',
    autoSubmitting: '自动提交中…',
    autoSubmit: '一键自动提交（卡密×凭证按序配对，池内 {n} 条）',
    pairHint: '配对规则：第 1 张有效 CDK ↔ Excel 第 1 条 Session，依次类推。提交后后台处理，下方看进度。',
    allSubmitted: '全部凭证已提交（{n} 笔）',
    watchProgress: '下方可继续查看处理进度',
    exportOk: '导出本批成功号（{n}）',
    noValidKeys: '没有可兑换的有效卡密',
    liveProgress: '实时进度',
    account: '账号',
    card: '银行卡',
    cardPending: '开卡后显示尾号',
    reset: '返回 · 重新开始',
    status: {
      pending_verify: '待验证',
      verify_ok: '卡密有效',
      verify_fail: '卡密无效',
      waiting_session: '待凭证',
      submitting: '提交中',
      processing: '处理中',
      success: '成功',
      failed: '失败',
    },
  },
  recharge: {
    title: '卡密兑换',
    subtitle: '先校验卡密和账号，通过后再开通，结果以到账为准',
    steps: { s1: '正在验证', s2: '支付准备', s3: '确认支付', s4: '订单完成' },
    flow: {
      verify: '正在验证',
      prepare: '支付准备',
      pay: '确认支付',
      done: '订单完成',
      orderNo: '订单号',
      copy: '复制',
      copied: '已复制',
      success: '充值成功！请刷新 ChatGPT 查看会员状态。',
      sessionOk: 'Session 格式正确',
      needCode: '先输入可用卡密',
      needCred: '卡密已通过，请在下方粘贴 Session',
      checkingAccount: '正在查询账号套餐…',
      subCanOpen: '{current} — 可开通 {target}',
      subCovered: '{current} — 已是同等或更高套餐',
      back: '返回',
      loading: '开通处理中',
      queuedHint: '不必盯着这一页。可先去开另一张，这张会留在本机队列继续同步。',
      openAnother: '去开另一张',
    },
    verifyCode: '验证卡密',
    verifyHint: '先验证卡密，通过后再填写 Session',
    redeemNow: '立即兑换',
    currentSub: '当前订阅',
    devPreview: '本地预览',
    phaseChecking: '检查中',
    phaseAccepted: '已受理',
    phaseForm: '表单',
    usedNoticeTitle: '该卡密已使用',
    usedNoticeEmail: '充值邮箱',
    usedNoticeHint: '该卡密已完成兑换，无需再次提交 Session。',
    step1Title: '验证卡密',
    cdkPlaceholder: '请输入卡密',
    codeValid: '码有效，可继续',
    verifying: '校验中…',
    previewNext: '预览 / 下一步',
    continueNext: '下一步',
    step2Title: 'ChatGPT 凭证',
    modeSession: 'Session',
    modeMailbox: '邮箱',
    sessionGuideBefore: '打开',
    sessionGuideCopy: '复制',
    sessionGuideJson: '完整 JSON',
    sessionGuideAfter: '（必须含 sessionToken）。已禁用纯 Access Token。',
    emailPlaceholder: 'email@outlook.com',
    passwordPlaceholder: '邮箱密码',
    prev: '上一步',
    startOpen: '开始开通',
    checking: '检查中…',
    sessionPassed: 'Session 已通过',
    checkingSession: '检查 Session…',
    accountVerified: '账号已验证',
    checkingHint: '正在预检账号是否可开通，常见 7–15 秒',
    checkingSlowHint: '比平时稍久，系统仍在处理。可以先离开，稍后在进度里查看，不必盯着这一页。',
    retryOpen: '再试一次',
    targetPlan: '目标套餐',
    accepted: '已受理',
    handoff: '已受理，处理中请稍后刷新查看，以到账为准。未到账请联系客服，不要重复提交。',
    continueRedeem: '继续兑换',
    viewProgress: '查看进度',
    step3Title: '确认兑换',
    confirmHint: '确认账号无误后即可开通。未开通成功时卡密不会消耗，可稍后再试。',
    currentPlan: '当前套餐',
    subStatus: '订阅状态',
    subUntil: '套餐到期',
    remaining: '剩余',
    autoRenew: '自动续费',
    lastPayAt: '最近付款时间',
    lastPay: '最近付款',
    payMethod: '支付方式',
    noAccountSummary: '账号已识别，可继续开通。',
    delinquentHint: '该账号可能有未结账单，开通成功率会低一些。',
    alreadySatisfiedBtn: '当前套餐已满足',
    redeem: '兑换',
    submitting: '提交中…',
    localQueue: '本机队列',
    queueCount: '本机队列 · {n} 笔',
    queueOpenCount: '{n} 笔处理中',
    queueSyncing: '同步中',
    queueExpand: '点击展开',
    queueCollapse: '收起',
    queueNoEmail: '暂无账号',
    queueBoundSession: '已绑定 Session',
    sessionEmailFound: '识别到账号 {email}',
    sessionUserFound: '识别到账号',
    step4Title: '兑换进度',
    stage: '阶段',
    polling: '实时轮询中（约 1s）',
    finished: '已结束',
    redeemAccount: '兑换账号',
    bankCard: '银行卡',
    cardPending: '开卡后显示尾号',
    progressAccept: '受理',
    progressCard: '开卡/资金',
    progressPay: '支付',
    progressDone: '开通',
    timeline: '处理明细',
    waitingEvents: '已提交，等待卡台返回步骤明细…',
    rawDebug: '原始响应（调试）',
    redeemFailed: '本次没有开通成功，卡密尚未消耗。',
    redeemDone: '开通完成，请到 ChatGPT 确认套餐。',
    notice: {
      sessionTitle: '登录状态已失效',
      sessionBody: '请重新打开 ChatGPT Session 页，复制完整 JSON 后再试。',
      busyTitle: '开通准备中',
      busyBody: '请稍等一会儿，再点「确认兑换」。卡密还在，不用换卡。',
      satisfiedTitle: '当前套餐已满足',
      satisfiedBody: '这个账号已经是同等或更高套餐，无需再开一次。',
      usedTitle: '卡密已使用',
      usedBody: '这张卡已经兑换过，不用再提交。',
      invalidTitle: '卡密不可用',
      invalidBody: '请核对卡密后重试，或联系发码方。',
      need_sessionTitle: '请先粘贴 Session',
      need_sessionBody: '需要完整 JSON（含 sessionToken），只用 Access Token 不行。',
      need_mailboxTitle: '请先填写邮箱和密码',
      need_mailboxBody: '填好邮箱和密码后，再点确认兑换。',
      need_codeTitle: '请先输入卡密',
      need_codeBody: '输入完整卡密后再继续。',
      failedTitle: '本次没有开通成功',
      failedBody: '卡密尚未消耗。请稍后重试，或联系客服。',
      processingTitle: '正在处理',
      processingBody: '请稍候，不要重复提交。',
      doneTitle: '开通完成',
      doneBody: '请到 ChatGPT 账号确认套餐。',
      delinquentTitle: '账号账单异常',
      delinquentBody: '仍可尝试开通，但成功率会低一些。',
      account_busyTitle: '账号开通中',
      account_busyBody: '这个账号已有开通中的订单，请等第一张到账后再兑。卡密未消耗。',
    },
    resultOpening: '开通中',
    resultReady: '准备开通',
    redeemAgain: '再兑一张',
    subActive: '有效',
    subExpired: '已到期 / 免费版',
    upstreamUnknown: '上游未提供',
    renewYes: '到期后自动续费',
    renewNo: '到期后不续费',
    paid: '已支付',
    cardExpiry: '卡片到期',
    defaultPay: '默认支付方式',
    expired: '已到期',
    daysHours: '{d} 天 {h} 小时',
    hoursMinutes: '{h} 小时 {m} 分钟',
    minutesOnly: '{m} 分钟',
    planFree: '免费版',
    satisfiedRenew: '账号已有 {plan} 或更高套餐，当前周期至 {until} 并会自动续费，取消并到期前不能重复购买。',
    satisfiedNoRenew: '账号已有 {plan} 或更高套餐，最早可在 {until} 后再次购买。',
    satisfiedUntil: '账号已有 {plan} 或更高套餐，当前周期至 {until}，暂不能重复购买。',
    satisfied: '账号已有 {plan} 或更高套餐，本次不能重复购买。',
    errEnterCode: '请输入卡密',
    errInvalidCode: '卡密无效或不可用',
    errNoToken: '卡密预览失败，请稍后重试',
    errNeedSession: '请粘贴完整 Session JSON（必须含 sessionToken），不能只用 Access Token',
    errNeedMailbox: '请填写邮箱与密码',
    errPreflight: '预检失败',
    errNoPreflight: '账号预检未完成，请返回上一步确认凭证后再试',
    allocating: '正在分配开通资源，请稍候…',
    allocatingTimeout: '开通资源还在准备，请稍后再点「开始开通」',
    errRejected: '兑换被拒绝',
    queueOpened: '已开通',
    queueAccepted: '已受理',
    queueReview: '待对账',
    queueFailed: '失败',
    queueProcessing: '处理中',
    queueUnused: '未使用',
    stepQueued: '排队受理',
    stepCredential: '凭证校验',
    stepPricing: '计价',
    stepCheckout: '开卡/绑卡',
    stepPayment: '支付扣款',
    stepSubscription: '订阅生效',
    stepInvoice: '账单',
    stepRenewal: '续费处理',
    stepReconcile: '对账确认',
    stepCompleted: '完成',
    stepPending: '处理中',
  },
  cdkLookup: {
    title: '卡密查询',
    subtitle: '查询卡密是否已使用，以及充值到哪个邮箱（不查询 token）',
    queryTitle: '输入卡密',
    queryHint: '输入完整卡密，系统仅返回使用状态与充值邮箱，不会返回 session / token。',
    cdkLabel: '卡密',
    cdkPlaceholder: 'SXC-XXXX-XXXX-XXXX-XXXX',
    cdkPlaceholderMulti: '一行一个卡密，支持批量查询\nSXC-XXXX-XXXX-XXXX-XXXX',
    batchCount: '{n} 个卡密',
    queryBtn: '查询卡密状态',
    resultTitle: '查询结果',
    cdkCode: '卡密',
    useStatus: '使用状态',
    rechargeEmail: '充值邮箱',
    emailEmpty: '—',
    plan: '套餐',
    usedAt: '使用时间',
    queryOther: '查询其他卡密',
    msgUsed: '该卡密已使用。',
    msgUnused: '该卡密尚未使用。',
    msgProcessing: '该卡密兑换处理中。',
    errNotFound: '未找到该卡密记录',
    errEmpty: '请输入至少一个卡密',
    errTooMany: '单次最多查询 {n} 个卡密',
    errNetwork: '网络错误，请重试',
    status: {
      unused: '未使用',
      used: '已使用',
      disabled: '已禁用',
      expired: '已过期',
      processing: '处理中',
      unknown: '未知',
    },
  },

  dashboard: {
    title: '账单工具',
    subtitle: 'Billing Tool · 查询账号订阅和账单信息',
    step1Title: '粘贴 Session 发起查询',
    hint: '粘贴需要查询账单的 Session JSON 或 access token。',
    inputLabel: 'Session JSON 或 access token',
    inputPlaceholder: '粘贴 Session JSON 或 access token',
    inputExample: '例如: {"access_token":"sk-xxx"} 或直接粘贴 token',
    queryBtn: '查询账单',
    resultTitle: '账单结果',
    accountInfo: '账号信息',
    email: '邮箱地址',
    subStatus: '订阅状态',
    currentPlan: '当前计划',
    billingInfo: '账单信息',
    billingAmount: '账单金额',
    currency: '货币',
    nextBilling: '下次计费日期',
    queryOther: '查询其他账号',
    notFoundTitle: '未找到该 Session 对应的账单',
    notFoundHint: '请检查 Session 是否输入正确',
    msgActive: '✓ 订阅激活，账号处于正常状态',
    msgInactive: '⚠ 订阅未激活，请检查账单信息',
    msgExpired: '✗ 订阅已过期，请更新支付信息',
    errQueryFailed: '查询失败',
    errNetwork: '网络错误，请重试',
    status: { active: '激活', inactive: '未激活', expired: '已过期' },
  },
  login: {
    title: '管理员登录',
    subtitle: '登录后才能进入管理后台、CDK 管理和账单上传。',
    username: '用户名',
    usernamePlaceholder: '请输入用户名',
    password: '密码',
    passwordPlaceholder: '请输入密码',
    loginBtn: '登录后台',
    loggingIn: '登录中...',
    errLoginFailed: '登录失败',
    errNetwork: '网络错误，请稍后重试',
  },
  notFound: {
    title: '页面不存在',
    home: '返回首页',
  },
}
